const createFormSlice = (set) => ({

   flexCategories: [],
   setFlexCategories: (newSelection) => {
      set({ flexCategories: newSelection })
   },

   isSending: false,
   toggleIsSending: () => {
      set((prevState) => ({ isSending: !prevState.isSending }))
   }

});

export default createFormSlice;
